
import Vue from 'vue'
import { IMenuItem } from '../store/state'
import MenuItem from './MenuItem.vue'
import { ITranslations } from '../store/state'
import { ISelfTestLink } from '../store/state'
import ExtraLinks from './ExtraLinks.vue'
//import MenuItem from ;

interface MenuData {
    visible: boolean;
	mobile: boolean;
}
interface MenuMethods {
    toggleMenu(): void
}
interface MenuComputed {
    menuItems: any
    translations: ITranslations,
    selfTestLink: ISelfTestLink,
    className: string
}

interface MenuProps {
    menuItems: IMenuItem[]
}

const component: Function = Vue.extend<MenuData, MenuMethods, MenuComputed, MenuProps>({
    name: 'Menu',
    data() {
        return { 
            visible: false,
            mobile: false
        }
    }, 
    created() {
		this.mobile = window.innerWidth <= 1199;
    },   
    computed: {
        menuItems() {
            return this.$store.getters.menuItems;
        },
        translations() {
			return this.$store.getters.translations
		},
        selfTestLink() {
            return this.$store.getters.selfTestLink;
        },
        className() {
            return this.$store.getters.className;
        }
	},
    methods: {
        toggleMenu() {
            this.visible = !this.visible;
            const body = document.querySelector("body");
            body ? body.classList.toggle("fixed") : null;
        }
    },
    components: {
		MenuItem,
        ExtraLinks
	},
})

export default component
